import React, { useState, useEffect } from 'react';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import Label from 'components/v2/forms/Label';
import Select from 'components/v2/select';
import TextField from 'components/v2/forms/TextField';
import Switch from 'react-switch';
import EditableSection from 'components/v2/EditableSection';
import { useTranslation } from 'react-i18next';
import SessionStore from 'stores/SessionStore';
import { checkPermissonForEditShipperBillingModule, payloadMappingOnlyForChanges, } from './utils';
export const AccountingSummary = ({ fields }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
        React.createElement(DescriptionListItem, { label: t('ACCOUNTING_HOLD'), className: "mb-4" }, fields.reason || t('NOT_SET')),
        React.createElement(DescriptionListItem, { label: t('NETSUITE_ID'), className: "mb-4" }, fields.net_suite_id),
        React.createElement(DescriptionListItem, { label: t('CAN_PAY_MANUALLY'), className: "mb-4" }, fields.can_pay_manually ? t('YES') : t('NO')),
        React.createElement(DescriptionListItem, { label: t('CRM_MAPPING_ID'), className: "mb-4" }, fields.crm_mapping_id)));
};
export const AccountingForm = ({ onChange, fields, saving, onSaveShipper, onSaveSuccess, onSaveFail, }) => {
    const { t } = useTranslation();
    const options = [
        {
            slug: 'good_standing',
            name: 'Good Standing',
            localizationSlug: 'GOOD_STANDING',
        },
        {
            slug: 'on_hold',
            name: 'On Hold',
            localizationSlug: 'ON_HOLD',
        },
    ];
    const saveForm = async () => {
        try {
            await onSaveShipper();
            onSaveSuccess(fields);
        }
        catch (e) {
            onSaveFail();
        }
    };
    useEffect(() => {
        if (saving) {
            saveForm();
        }
    }, [saving]);
    const accountingAdminAccess = () => {
        return SessionStore.hasAccountingAdminRole() || SessionStore.isAdmin();
    };
    return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
        accountingAdminAccess() && (React.createElement("div", { className: "" },
            React.createElement(Label, { htmlFor: "accountingHold" }, t('ACCOUNTING_HOLD')),
            React.createElement(Select, { id: "accountingHold", labelClassName: "m-0", items: options, selected: fields.reason, onSelect: ({ name }) => onChange('reason', name), valueKey: "name", textKey: "localizationSlug" }))),
        React.createElement("div", null,
            React.createElement(Label, { htmlFor: "netsuiteId" }, t('NETSUITE_ID')),
            React.createElement(TextField, { className: "mt-1", value: fields.net_suite_id, onChange: (val) => onChange('net_suite_id', val) })),
        React.createElement("div", null,
            React.createElement(Label, { htmlFor: "can_pay_manually" }, t('CAN_PAY_MANUALLY')),
            React.createElement(Switch, { id: "can_pay_manually", className: "mt-1", checked: fields.can_pay_manually, onChange: (val) => onChange('can_pay_manually', val) })),
        React.createElement("div", null,
            React.createElement(Label, { htmlFor: "crm_mapping_id" }, t('CRM_MAPPING_ID')),
            React.createElement(TextField, { value: fields.crm_mapping_id, className: "mt-1", onChange: (val) => onChange('crm_mapping_id', val) }))));
};
const AccountingSettings = ({ className, onUpdateShipper, data }) => {
    const { t } = useTranslation();
    const [initialData, setinitialData] = useState(data);
    const [accountingData, setAccountingData] = useState(data);
    const getInitData = () => {
        if (data) {
            setinitialData(data);
            setAccountingData(data);
        }
    };
    useEffect(() => {
        getInitData();
    }, [data]);
    const handleSave = async () => {
        const payload = payloadMappingOnlyForChanges(initialData, accountingData);
        if (payload.reason) {
            payload.accounting = {
                on_hold: payload.reason !== 'Good Standing',
                reason: payload.reason,
            };
        }
        if (Object.keys(payload).length) {
            await onUpdateShipper(payload);
        }
    };
    const onChange = (field, value) => {
        setAccountingData((prev) => (Object.assign(Object.assign({}, prev), { [field]: value })));
    };
    const handleAfterSave = (onSaveSuccess) => {
        return (updatedData = {}) => {
            setinitialData((prev) => (Object.assign(Object.assign({}, prev), updatedData)));
            onSaveSuccess();
        };
    };
    return (React.createElement(EditableSection, { className: className, title: t('ACCOUNTING'), canEdit: checkPermissonForEditShipperBillingModule(), onSave: handleSave }, (editMode, saving, onSaveSuccess, onSaveFail) => editMode ? (React.createElement(AccountingForm, { fields: accountingData, saving: saving, onChange: onChange, onSaveSuccess: handleAfterSave(onSaveSuccess), onSaveFail: () => onSaveFail(), onSaveShipper: () => handleSave() })) : (React.createElement(AccountingSummary, { fields: initialData }))));
};
export default AccountingSettings;
